import { mode, transparentize } from '@chakra-ui/theme-tools';
const parts = ['errorText', 'errorIcon', 'requiredIndicator', 'helperText'];
function baseStyleErrorText(props) {
    return {
        color: mode('red.500', 'red.300')(props),
        mt: 1,
        fontSize: 'sm',
    };
}
function baseStyleRequiredIndicator(props) {
    return {
        ml: 1,
        color: mode('red.500', 'red.300')(props),
    };
}
function baseStyleHelperText(props) {
    const { theme, isDisabled } = props;
    return {
        mt: 1,
        lineHeight: 'normal',
        fontSize: 'sm',
        color: isDisabled
            ? mode(transparentize(`gray.600`, 0.36)(theme), transparentize('white', 0.36)(theme))(props)
            : mode(transparentize(`gray.600`, 0.67)(theme), transparentize('white', 0.67)(theme))(props),
    };
}
function baseStyleErrorIcon(props) {
    return {
        mr: '0.5em',
        color: mode('red.500', 'red.300')(props),
    };
}
const baseStyle = (props) => ({
    errorText: baseStyleErrorText(props),
    requiredIndicator: baseStyleRequiredIndicator(props),
    helperText: baseStyleHelperText(props),
    errorIcon: baseStyleErrorIcon(props),
});
export default {
    parts,
    baseStyle,
};
//# sourceMappingURL=form.js.map